import { Component } from '@angular/core';

@Component({
    selector: 'em-block-info',
    templateUrl: './block-info.component.html',
    styleUrls: ['./block-info.component.scss'],
    standalone: false
})
export class BlockInfoComponent {

}
